module.exports = __webpack_public_path__ + "img/list.a37c80c6.svg";